export default __webpack_public_path__ + "static/media/About3.e11033c2.jpg";